module.exports = __webpack_public_path__ + "static/media/lancome.4bfd15fa.jpg";